// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/icons/tick.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

label.custom-radio-button input[type=radio] {
  opacity: 0;
}

input[type=datetime-local] {
  padding-bottom: 0px !important;
}

label.custom-radio-button input[type=radio] ~ .helping-el {
  background-color: #ffffff;
  border: 1.5px solid #10b981;
  border-radius: 50%;
  display: inline-block;
  margin-right: 7px;
  padding: 6px;
  position: relative;
  top: 3px;
}

/* scrollbar width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.ChapterWiseMarks tbody td {
  padding: 5px;
}

/* scrollbar bg color */
::-webkit-scrollbar-track {
  background: transparent;
}

.customSize14 .customSizeWrapper .container input {
  font-size: 14px;
}

.customSize16 .customSizeWrapper .container input {
  font-size: 16px;
}

.customSize18 .customSizeWrapper .container input {
  font-size: 18px;
}

.customSize14 img {
  width: 12% !important;
}

.customSize16 img {
  width: 18% !important;
}

.customSize18 img {
  width: 20% !important;
}

.optionImageWrappercustomSize14 img {
  height: 48px !important;
  width: 48px !important;
}

.optionImageWrappercustomSize16 img {
  height: 60px !important;
  width: 60px !important;
}

.optionImageWrappercustomSize18 img {
  height: 80px !important;
  width: 80px !important;
}

/* scrollbar color */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

/* scrollbar colors on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

label.custom-radio-button input[type=radio]:checked ~ .helping-el {
  border: 1.5px solid #10b981;
}

label.custom-radio-button input[type=radio]:checked ~ .helping-el:after {
  background-color: #10b981;
  border-radius: 50%;
  content: " ";
  font-size: 33px;
  left: 2px;
  position: absolute;
  top: 2px;
  height: 8px;
  width: 8px;
}

.custom-checkbox {
  display: block;
}

.custom-checkbox input {
  display: none;
}

.custom-checkbox label {
  cursor: pointer;
  display: flex;
  align-items: center;
  column-gap: 4px;
}

.custom-checkbox label:before {
  content: "";
  width: 20px;
  height: 20px;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  background-image: none;
}

.custom-checkbox input:checked + label:before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #245501;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-size: 10px 10px;
}

.custom-checkbox.secondary input:checked + label:before {
  content: "";
  background-color: #10b981 !important;
}

tbody td {
  padding: 30px;
}

tbody tr:nth-child(odd) {
  background-color: rgb(242, 242, 243);
}

.react-confirm-alert-overlay {
  background: rgba(17, 24, 39, 0.5) !important;
}

.overlay-custom-class-name .react-confirm-alert .react-confirm-alert-body {
  text-align: center;
}
.overlay-custom-class-name .react-confirm-alert .react-confirm-alert-body h1 {
  color: #000;
  font-size: 22px;
  padding-bottom: 26px;
}
.overlay-custom-class-name .react-confirm-alert .react-confirm-alert-button-group {
  display: flex;
  justify-content: center;
  gap: 30px;
}
.overlay-custom-class-name .react-confirm-alert .react-confirm-alert-button-group button {
  border-radius: 5px;
  background: #245501;
  margin: 0 !important;
  height: 100%;
}
.overlay-custom-class-name .react-confirm-alert .react-confirm-alert-button-group button[label=Yes] {
  background: #245501;
}
.overlay-custom-class-name .react-confirm-alert .react-confirm-alert-button-group .cancel-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #245501;
  background-color: transparent !important;
  color: #245501;
  font-size: 16px;
  font-weight: 600;
  text-transform: capitalize;
  margin: 0;
}
.overlay-custom-class-name .react-confirm-alert .react-confirm-alert-button-group .delete-btn {
  font-size: 16px;
  font-weight: 600;
}

.profilepic .error-message {
  color: rgb(244, 67, 54);
  font-size: 12px;
}

input[type=radio] {
  color: #10b981;
}
input[type=radio]:hover {
  cursor: pointer;
}

input[type=radio]:checked {
  border-color: #10b981 !important;
}

input[type=radio]:focus {
  --tw-ring-color: transparent !important;
}

:root {
  --circle-size: clamp(1rem, 30px, 2rem);
  --spacing: clamp(0.25rem, 2vw, 0.5rem);
}

.c-stepper {
  display: flex;
}

.c-stepper__item {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  text-align: center;
}
.c-stepper__item:before {
  --size: 3rem;
  content: "";
  display: block;
  width: var(--circle-size);
  height: var(--circle-size);
  border-radius: 50%;
  background-color: lightgrey;
  background-color: red;
  opacity: 0;
  margin: 0 auto 1rem;
}
.c-stepper__item:not(:last-child):after {
  content: "";
  position: relative;
  top: calc(var(--circle-size) / 2);
  width: calc(100% - var(--circle-size) - var(--spacing) * 2);
  left: calc(32% + var(--circle-size) / 2 + var(--spacing));
  height: 2px;
  background-color: #e0e0e0;
  order: -1;
}

.c-stepper__title {
  font-size: 12px;
  margin-bottom: 0.5rem;
}

.c-stepper__desc {
  color: grey;
  font-size: clamp(0.85rem, 2vw, 1rem);
  padding-left: var(--spacing);
  padding-right: var(--spacing);
}

/*** Non-demo CSS ***/
.wrapper {
  max-width: 1000px;
  margin: 2rem auto 0;
}

iframe#webpack-dev-server-client-overlay {
  display: none !important;
}

.btn-color {
  border: 1px solid #1c1c2c !important;
  background: #fff !important;
  color: #1c1c2c !important;
}

.verify-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  box-sizing: border-box;
  background-image: linear-gradient(45deg, #be7373, #82c98d);
  transition: transform 0.3s ease;
  padding: 0 20px;
}

.verify-box:hover {
  transform: scale(1.1);
}

.verify-border {
  padding: 20px;
  border: 2px solid #ccc; /* Lighter border */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Lighter shadow */
  text-align: center;
  transition: box-shadow 0.3s ease, border-color 0.3s ease; /* Transition for hover effect */
  height: 150px; /* Set the height of the box */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.verify-border:hover {
  border-color: #aaa; /* Slightly darker border on hover */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2); /* Slightly stronger shadow on hover */
}

h1.leading-8 {
  font-size: 20px;
}

.pad-0 {
  padding: 0 !important;
}

.styled-select {
  position: relative;
  height: 46px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgba(15, 0, 64, 0.08);
  color: #333333;
  padding: 0 16px;
  background: #f4f4f4;
  cursor: pointer;
}

.styled-select .container {
  position: relative;
  height: 50px;
  border: 1px solid transparent;
  color: rgba(255, 255, 255, 0.8);
  min-width: max-content;
  color: #333333;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid rgba(15, 0, 64, 0.08);
  background: #f4f4f4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  margin-top: 9px;
}

.styled-select .container.errors {
  border-color: rgb(244, 67, 54);
}

/* Default Quill sizes */
p .ql-size-small {
  font-size: 0.75em;
}

p .ql-size-large {
  font-size: 1.5em;
}

p .ql-size-huge {
  font-size: 2.5em;
}

/* Custom sizes for headers */
h1 .ql-size-large {
  font-size: 3em; /* Adjust to your needs */
}

h2 .ql-size-large {
  font-size: 2.5em; /* Adjust to your needs */
}

h3 .ql-size-large {
  font-size: 2em; /* Adjust to your needs */
}

h1 .ql-size-huge {
  font-size: 4em; /* Huge for h1 */
}

h2 .ql-size-huge {
  font-size: 3.5em; /* Huge for h2 */
}

h3 .ql-size-huge {
  font-size: 3em; /* Huge for h3 */
}

.privacy-policy h1 {
  font-size: 2em; /* Huge for h1 */
}

.privacy-policy h2 {
  font-size: 1.5em; /* Huge for h1 */
}

.privacy-policy h3 {
  font-size: 1.17em; /* Huge for h1 */
}

.styled-select .menu-list {
  margin: 0;
  z-index: 9999;
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  top: 55px;
  padding: 15px;
  max-height: 200px;
  overflow-y: auto;
  gap: 6px;
  border-radius: 0px 0px 5px 5px;
  background: #fff;
  box-shadow: 0px 0px 0.836px 0px rgba(9, 30, 66, 0.31), 0px 2.507px 4.178px 0px rgba(9, 30, 66, 0.2);
}

.epr_-lzq3oa {
  height: 45px !important;
}

.epr_xexhgb {
  margin-top: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;;EAEE,wBAAA;EACA,SAAA;AACF;;AAEA,YAAA;AACA;EACE,0BAAA;AACF;;AAEA;EACE,UAAA;AACF;;AACA;EACE,8BAAA;AAEF;;AAAA;EACE,yBAAA;EACA,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AAGF;;AADA,oBAAA;AACA;EACE,UAAA;EACA,WAAA;AAIF;;AAFA;EACE,YAAA;AAKF;;AAHA,uBAAA;AACA;EACE,uBAAA;AAMF;;AAFA;EACE,eAAA;AAKF;;AAFA;EACE,eAAA;AAKF;;AAFA;EACE,eAAA;AAKF;;AAHA;EACE,qBAAA;AAMF;;AAHA;EACE,qBAAA;AAMF;;AAHA;EACE,qBAAA;AAMF;;AAHA;EACE,uBAAA;EACA,sBAAA;AAMF;;AAHA;EACE,uBAAA;EACA,sBAAA;AAMF;;AAHA;EACE,uBAAA;EACA,sBAAA;AAMF;;AAHA,oBAAA;AACA;EACE,gBAAA;EACA,kBAAA;AAMF;;AAHA,8BAAA;AACA;EACE,gBAAA;AAMF;;AAJA;EACE,2BAAA;AAOF;;AAJA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AAOF;;AAJA;EACE,cAAA;AAOF;;AAJA;EACE,aAAA;AAOF;;AAJA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAOF;;AAJA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AAOF;;AAJA;EACE,WAAA;EACA,yDAAA;EACA,yBAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;AAOF;;AAJA;EACE,WAAA;EACA,oCAAA;AAOF;;AAFA;EACE,aAAA;AAKF;;AAFA;EACE,oCAAA;AAKF;;AADA;EACE,4CAAA;AAIF;;AACI;EACE,kBAAA;AAEN;AAAM;EACE,WAAA;EACA,eAAA;EACA,oBAAA;AAER;AAEI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAAN;AAEM;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;AAAR;AAGM;EACE,mBAAA;AADR;AAIM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AAFR;AAKM;EACE,eAAA;EACA,gBAAA;AAHR;;AASA;EACE,uBAAA;EACA,eAAA;AANF;;AAQA;EACE,cAAA;AALF;AAOE;EACE,eAAA;AALJ;;AASA;EACE,gCAAA;AANF;;AASA;EACE,uCAAA;AANF;;AASA;EACE,sCAAA;EACA,sCAAA;AANF;;AASA;EACE,aAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AANF;AAQE;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;AANJ;AAUI;EACE,WAAA;EACA,kBAAA;EACA,iCAAA;EACA,2DAAA;EACA,yDAAA;EACA,WAAA;EACA,yBAAA;EACA,SAAA;AARN;;AAaA;EACE,eAAA;EACA,qBAAA;AAVF;;AAaA;EACE,WAAA;EACA,oCAAA;EACA,4BAAA;EACA,6BAAA;AAVF;;AAaA,qBAAA;AAEA;EACE,iBAAA;EACA,mBAAA;AAXF;;AAaA;EACE,wBAAA;AAVF;;AAYA;EACE,oCAAA;EACA,2BAAA;EACA,yBAAA;AATF;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,0DAAA;EACA,+BAAA;EACA,eAAA;AARF;;AAUA;EACE,qBAAA;AAPF;;AASA;EACE,aAAA;EACA,sBAAA,EAAA,mBAAA;EACA,wCAAA,EAAA,mBAAA;EACA,kBAAA;EACA,wDACE,EACwB,gCAAA;EAC1B,aAAA,EAAA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AARF;;AAUA;EACE,kBAAA,EAAA,oCAAA;EACA,yCAAA,EAAA,sCAAA;AAPF;;AASA;EACE,eAAA;AANF;;AAQA;EACE,qBAAA;AALF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EAEA,6BAAA;EACA,+BAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;AAJF;;AAOA;EACE,8BAAA;AAJF;;AAOA,wBAAA;AACA;EACE,iBAAA;AAJF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA,6BAAA;AACC;EACC,cAAA,EAAA,yBAAA;AALF;;AAQC;EACC,gBAAA,EAAA,yBAAA;AALF;;AAQC;EACC,cAAA,EAAA,yBAAA;AALF;;AAQC;EACC,cAAA,EAAA,gBAAA;AALF;;AAQC;EACC,gBAAA,EAAA,gBAAA;AALF;;AAQC;EACC,cAAA,EAAA,gBAAA;AALF;;AAQA;EACE,cAAA,EAAA,gBAAA;AALF;;AAQA;EACE,gBAAA,EAAA,gBAAA;AALF;;AAQA;EACE,iBAAA,EAAA,gBAAA;AALF;;AASA;EACE,SAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,QAAA;EACA,8BAAA;EACA,gBAAA;EACA,mGACE;AAPJ;;AAUA;EACE,uBAAA;AAPF;;AASA;EACE,2BAAA;AANF","sourcesContent":["input::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\nlabel.custom-radio-button input[type=\"radio\"] {\n  opacity: 0;\n}\ninput[type=\"datetime-local\"] {\n  padding-bottom: 0px !important;\n}\nlabel.custom-radio-button input[type=\"radio\"] ~ .helping-el {\n  background-color: #ffffff;\n  border: 1.5px solid #10b981;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 7px;\n  padding: 6px;\n  position: relative;\n  top: 3px;\n}\n/* scrollbar width */\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n.ChapterWiseMarks tbody td {\n  padding: 5px;\n}\n/* scrollbar bg color */\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n//text size css to handle with button\n.customSize14 .customSizeWrapper .container input {\n  font-size: 14px;\n}\n\n.customSize16 .customSizeWrapper .container input {\n  font-size: 16px;\n}\n\n.customSize18 .customSizeWrapper .container input {\n  font-size: 18px;\n}\n.customSize14 img {\n  width: 12% !important;\n}\n\n.customSize16 img {\n  width: 18% !important;\n}\n\n.customSize18 img {\n  width: 20% !important;\n}\n\n.optionImageWrappercustomSize14 img {\n  height: 48px !important;\n  width: 48px !important;\n}\n\n.optionImageWrappercustomSize16 img {\n  height: 60px !important;\n  width: 60px !important;\n}\n\n.optionImageWrappercustomSize18 img {\n  height: 80px !important;\n  width: 80px !important;\n}\n\n/* scrollbar color */\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 5px;\n}\n\n/* scrollbar colors on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\nlabel.custom-radio-button input[type=\"radio\"]:checked ~ .helping-el {\n  border: 1.5px solid #10b981;\n}\n\nlabel.custom-radio-button input[type=\"radio\"]:checked ~ .helping-el:after {\n  background-color: #10b981;\n  border-radius: 50%;\n  content: \" \";\n  font-size: 33px;\n  left: 2px;\n  position: absolute;\n  top: 2px;\n  height: 8px;\n  width: 8px;\n}\n\n.custom-checkbox {\n  display: block;\n}\n\n.custom-checkbox input {\n  display: none;\n}\n\n.custom-checkbox label {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  column-gap: 4px;\n}\n\n.custom-checkbox label:before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  cursor: pointer;\n  background-image: none;\n}\n\n.custom-checkbox input:checked + label:before {\n  content: \"\";\n  background-image: url(\"./assets/icons/tick.svg\");\n  background-color: #245501;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  background-size: 10px 10px;\n}\n\n.custom-checkbox.secondary input:checked + label:before {\n  content: \"\";\n  background-color: #10b981 !important;\n}\n\n// table style\n\ntbody td {\n  padding: 30px;\n}\n\ntbody tr:nth-child(odd) {\n  background-color: rgb(242, 242, 243);\n}\n\n//  confirm box css override\n.react-confirm-alert-overlay {\n  background: rgb(17 24 39 / 50%) !important;\n}\n\n.overlay-custom-class-name {\n  .react-confirm-alert {\n    .react-confirm-alert-body {\n      text-align: center;\n\n      h1 {\n        color: #000;\n        font-size: 22px;\n        padding-bottom: 26px;\n      }\n    }\n\n    .react-confirm-alert-button-group {\n      display: flex;\n      justify-content: center;\n      gap: 30px;\n\n      button {\n        border-radius: 5px;\n        background: #245501;\n        margin: 0 !important;\n        height: 100%;\n      }\n\n      button[label=\"Yes\"] {\n        background: #245501;\n      }\n\n      .cancel-btn {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border: 1px solid #245501;\n        background-color: transparent !important;\n        color: #245501;\n        font-size: 16px;\n        font-weight: 600;\n        text-transform: capitalize;\n        margin: 0;\n      }\n\n      .delete-btn {\n        font-size: 16px;\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n.profilepic .error-message {\n  color: rgb(244, 67, 54);\n  font-size: 12px;\n}\ninput[type=\"radio\"] {\n  color: #10b981;\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\ninput[type=\"radio\"]:checked {\n  border-color: #10b981 !important;\n}\n\ninput[type=\"radio\"]:focus {\n  --tw-ring-color: transparent !important;\n}\n\n:root {\n  --circle-size: clamp(1rem, 30px, 2rem);\n  --spacing: clamp(0.25rem, 2vw, 0.5rem);\n}\n\n.c-stepper {\n  display: flex;\n}\n\n.c-stepper__item {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  text-align: center;\n\n  &:before {\n    --size: 3rem;\n    content: \"\";\n    display: block;\n    width: var(--circle-size);\n    height: var(--circle-size);\n    border-radius: 50%;\n    background-color: lightgrey;\n    background-color: red;\n    opacity: 0;\n    margin: 0 auto 1rem;\n  }\n\n  &:not(:last-child) {\n    &:after {\n      content: \"\";\n      position: relative;\n      top: calc(var(--circle-size) / 2);\n      width: calc(100% - var(--circle-size) - calc(var(--spacing) * 2));\n      left: calc(32% + calc(var(--circle-size) / 2 + var(--spacing)));\n      height: 2px;\n      background-color: #e0e0e0;\n      order: -1;\n    }\n  }\n}\n\n.c-stepper__title {\n  font-size: 12px;\n  margin-bottom: 0.5rem;\n}\n\n.c-stepper__desc {\n  color: grey;\n  font-size: clamp(0.85rem, 2vw, 1rem);\n  padding-left: var(--spacing);\n  padding-right: var(--spacing);\n}\n\n/*** Non-demo CSS ***/\n\n.wrapper {\n  max-width: 1000px;\n  margin: 2rem auto 0;\n}\niframe#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n.btn-color {\n  border: 1px solid #1c1c2c !important;\n  background: #fff !important;\n  color: #1c1c2c !important;\n}\n.verify-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  box-sizing: border-box;\n  background-image: linear-gradient(45deg, #be7373, #82c98d);\n  transition: transform 0.3s ease;\n  padding: 0 20px;\n}\n.verify-box:hover {\n  transform: scale(1.1);\n}\n.verify-border {\n  padding: 20px;\n  border: 2px solid #ccc; /* Lighter border */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Lighter shadow */\n  text-align: center;\n  transition:\n    box-shadow 0.3s ease,\n    border-color 0.3s ease; /* Transition for hover effect */\n  height: 150px; /* Set the height of the box */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n}\n.verify-border:hover {\n  border-color: #aaa; /* Slightly darker border on hover */\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2); /* Slightly stronger shadow on hover */\n}\nh1.leading-8 {\n  font-size: 20px;\n}\n.pad-0 {\n  padding: 0 !important;\n}\n.styled-select {\n  position: relative;\n  height: 46px;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgba(15, 0, 64, 0.08);\n  color: #333333;\n  padding: 0 16px;\n  background: #f4f4f4;\n  cursor: pointer;\n}\n\n.styled-select .container {\n  position: relative;\n  height: 50px;\n  border-radius: 12px;\n  border: 1px solid transparent;\n  color: rgba(255, 255, 255, 0.8);\n  min-width: max-content;\n  color: #333333;\n  padding: 0 16px;\n  border-radius: 10px;\n  border: 1px solid rgba(15, 0, 64, 0.08);\n  background: #f4f4f4;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  gap: 10px;\n  margin-top: 9px;\n}\n\n.styled-select .container.errors {\n  border-color: rgb(244, 67, 54);\n}\n\n/* Default Quill sizes */\np .ql-size-small {\n  font-size: 0.75em;\n}\n\n\np .ql-size-large {\n  font-size: 1.5em;\n}\n\np .ql-size-huge {\n  font-size: 2.5em;\n}\n\n/* Custom sizes for headers */\n h1 .ql-size-large {\n  font-size: 3em; /* Adjust to your needs */\n}\n\n h2 .ql-size-large {\n  font-size: 2.5em; /* Adjust to your needs */\n}\n\n h3 .ql-size-large {\n  font-size: 2em; /* Adjust to your needs */\n}\n\n h1 .ql-size-huge {\n  font-size: 4em; /* Huge for h1 */\n}\n\n h2 .ql-size-huge {\n  font-size: 3.5em; /* Huge for h2 */\n}\n\n h3 .ql-size-huge {\n  font-size: 3em; /* Huge for h3 */\n}\n\n.privacy-policy h1 {\n  font-size: 2em; /* Huge for h1 */\n}\n\n.privacy-policy h2 {\n  font-size: 1.5em; /* Huge for h1 */\n}\n\n.privacy-policy h3 {\n  font-size: 1.17em; /* Huge for h1 */\n}\n\n\n.styled-select .menu-list {\n  margin: 0;\n  z-index: 9999;\n  position: absolute;\n  right: 0;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  top: 55px;\n  padding: 15px;\n  max-height: 200px;\n  overflow-y: auto;\n  gap: 6px;\n  border-radius: 0px 0px 5px 5px;\n  background: #fff;\n  box-shadow:\n    0px 0px 0.836px 0px rgba(9, 30, 66, 0.31),\n    0px 2.507px 4.178px 0px rgba(9, 30, 66, 0.2);\n}\n.epr_-lzq3oa {\n  height: 45px !important;\n}\n.epr_xexhgb {\n  margin-top: 12px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
